
<script>
import BarList from '../components/bar-list'
import { apiORDSdelete } from '../shared/api-functions'
import { SysVars } from '../main';
import CrmMotivoForm from './crm-motivo-form'
import apiCrm from '../api/api-crm.js'

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            motivo: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            currentMotivo: {},
            codmotivo: null,
        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        motivoList: function () {
            return this.$store.getters.getMotivoCrmList
        },
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },
    },

    methods: {
        handleEdit (motivo) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.$set(motivo, 'show', true)
        },

        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.showForm = true
        },

        closeForm(motivo) {
            if (motivo)
              motivo.show = false
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codmotivo":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadMotivoCrm', { filter: this.filter, page: this.nextPage } )
            this.offset = ''
        },

        handleDelete (motivo) {
            //BOTAO Excluir
            this.apiMotivoDelete(motivo.codmotivo)
            this.loadData()
        },

    },

    components: {
        BarList, CrmMotivoForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="false"
                single-entity="Motivo de Perda" 
                plural-entity=""
                @search="search"
                @new="handleNew"
                @refresh="loadData">
            </bar-list>
            <br>
            <div class="default-container">
                <crm-motivo-form v-if="showForm" :index="codmotivo" :crud="crud" @closeform="closeForm"></crm-motivo-form>
                <alert v-if="motivoList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="motivo in motivoList" :key="motivo.codmotivo">
                    <div class="box">
                        <div class="row" v-show="!motivo.show">
                            <!-- <div class="col-md-2 col-3">
                                <span class="lbl-list"> {{metadata.motivocrm.codmotivo.label}} </span>
                                <span class="data-list">{{ motivo.codmotivo }}</span>
                            </div> -->
                            <div class="col-md-10 col-6">
                                <!-- <span class="lbl-list"> {{metadata.motivocrm.descricao.label}} </span> -->
                                <span class="lbl-title-produto">{{ motivo.descricao }}</span>
                            </div>
                            <div class="col-md-2 col-12">
                                <bar-grid 
                                    :options="{barDefault: true, btnDelete: true, btnEdit: true}" 
                                    :moreActions="[]" 
                                    @edit="handleEdit(motivo)" 
                                    @delete="handleDelete(motivo)">
                                </bar-grid>
                            </div>
                        </div>
                        <crm-motivo-form v-if="motivo.show" :index="motivo.codmotivo" :crud="crud" @closeform="closeForm(motivo)"></crm-motivo-form>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-motivo-list.vue